<template>
	<div class="PageUserOverview">
		<div v-if="channel.roles[role]" class="row margin-bottom-xlarge">
			<div class="col-xs-12">
				<h1 class="st-headline st-headline--1">{{ $t(channel.roles[role].plural) }}</h1>
			</div>
		</div>

		<div class="row margin-bottom-xlarge margin-top-xlarge">
			<div class="col-xs-12">
				<UserList
				v-if="role == 'kam'"
				:role="role"
				:rolename="'kam'"
				:roleleadername="'kam_leader'"
				></UserList>
			</div>
		</div>
	</div>
</template>

<script>
import UserList from '@/components/UserList';
export default {
	name: 'PageUserOverview',
	components: {
		UserList
	},
	computed: {
		channel(){
			return this.$store.getters.channel;
		}
	},
	props: ['role']
}
</script>



// WEBPACK FOOTER //
// src/pages/PageUserOverview.vue